module.exports = __webpack_public_path__ + "img/ada-badge-2022_en.56d3754.svg";